import React, { useState } from 'react';
import { WindowInformation } from '../services/window-information';
import { Modal, Pressable, TouchableOpacity, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Tooltip from './Tooltip';
import MyAppText from './MyAppText';

interface Props {
    content: string | React.ReactNode;
    tooltipStyle?: React.CSSProperties;
    tooltipDirection?: 'right' | 'left' | 'top';
    maxWidth?: number;
}

export function CustomTooltip({ content, tooltipStyle, tooltipDirection = 'right', maxWidth }: Props) {
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();

    const [openThresholdDetailTooltip, setOpenThresholdDetailTooltip] = useState<boolean>(false);

    return (<>
        {windowInfo.isMobile
            ? <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
                <TouchableOpacity onPress={() => setOpenThresholdDetailTooltip(true)}>
                    <FontAwesomeIcon icon={faCircleInfo} fontSize={14} color={theme.colors.neutral['500']} />
                </TouchableOpacity>
            </View>
            : <Tooltip
                useSimpleBox
                tooltipDirection={tooltipDirection}
                tooltipContent={content}
                style={tooltipStyle ? tooltipStyle : {
                    color: theme.colors.white['500'],
                    padding: 16,
                    borderRadius: 12,
                    justifyContent: 'center',
                    zIndex: 9999,
                    width: maxWidth ?? 443,
                    background: theme.colors.neutral['500'],
                }}
            >
                <FontAwesomeIcon icon={faCircleInfo} fontSize={14} color={theme.colors.neutral['500']} />
            </Tooltip>}
        <Modal
            visible={openThresholdDetailTooltip}
            animationType='fade'
            onRequestClose={() => {
                setOpenThresholdDetailTooltip(false);
            }}
            transparent={true}
            collapsable
        >
            <Pressable style={styles.modalContainer} onPressOut={() => setOpenThresholdDetailTooltip(false)}>
                <View style={styles.tooltipAsModalContainer}>
                    {typeof content === 'string'
                        ? <MyAppText style={{ color: theme.colors.white['500'] }}>{content}</MyAppText>
                        : content
                    }
                </View>
            </Pressable>
        </Modal>
    </>);
}

const stylesheet = createStyleSheet(theme => ({
    modalContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
    },
    tooltipAsModalContainer: {
        flexDirection: 'column',
        width: '95%',
        maxHeight: '95%',
        rowGap: 12,
        backgroundColor: theme.colors.neutral['500'],
        padding: 12,
        zIndex: 9999,
        borderRadius: 8,
        borderTopLeftRadius: 8,
        shadowColor: '#000',
        shadowOpacity: 0.45,
        shadowOffset: {
            height: -2,
            width: 2
        },
        shadowRadius: 10,
    },
}));
